import { Observable } from 'rxjs';
import { CreateCustomerUserRequest } from '../../models/customer-user/customer-user-create.model';
import { ViewCustomerUserModel } from '../../models/customer-user/customer-users.model';

export abstract class CustomerUserRepository {
  abstract createCustomerUser(user: CreateCustomerUserRequest): Observable<any>;

  abstract updateCustomerUserEmail(
    userId: string,
    email: string
  ): Observable<any>;

  abstract duplicateCustomerUser(
    sourceUserId: string,
    email: string,
    npi?: string
  ): Observable<any>;

  abstract getAllCustomerUsers(
    customerId: string
  ): Observable<ViewCustomerUserModel>;

  abstract deleteUser(userId: string): Observable<any>;

  abstract replaceAdminUser(
    oldAdminId: string,
    newAdminId: string
  ): Observable<any>;
}
